export default class Template {
    public name: string | null
    public subject: string | null
    public body: string | null
    public orderStatus: string | null
}
